if (!customElements.get('pm-care-guide')) {
  customElements.define(
    'pm-care-guide',
    class PmCareGuide extends HTMLElement {
      connectedCallback() {
        this.mqDesktop = window.matchMedia('(min-width: 750px)');
        this.navItems = Array.prototype.slice.call(this.querySelectorAll('[data-care-nav-item]'));
        this.chapters = Array.prototype.slice.call(this.querySelectorAll('[data-care-chapter]'));

        this.navItems.forEach(function (item) {
          item.addEventListener('click', this.onNavItemClick.bind(this));
        }, this);

        this.chapters.forEach(function (chapter) {
          var toggle = chapter.querySelector('[data-care-chapter-toggle]');
          if (toggle) toggle.addEventListener('click', this.onChapterToggleClick.bind(this, chapter));
          this.resetSteps(chapter);
        }, this);

        /* Steps are an exclusive group (details[name]): one row is always
           expanded, so clicking the open row must not collapse it - that would
           leave the column empty and shift the whole layout. */
        Array.prototype.forEach.call(this.querySelectorAll('.pm-care-guide__accordion-summary'), function (summary) {
          summary.addEventListener('click', function (event) {
            var row = summary.closest('.pm-care-guide__accordion-row');
            if (!row || !row.open) return;
            var chapter = row.closest('[data-care-chapter]');
            var open = chapter ? chapter.querySelectorAll('.pm-care-guide__accordion-row[open]') : [];
            if (open.length <= 1) event.preventDefault();
          });
        });

        this.applyBreakpointDefaults();
        /* Flush the collapsed state through style resolution before the CSS
           transitions are armed again (see the [data-ready] rule), so the
           initial collapse is instant instead of animated. */
        void this.offsetHeight;
        this.setAttribute('data-ready', '');

        this.mqDesktop.addEventListener('change', this.applyBreakpointDefaults.bind(this));
      }

      /* The two layouts have opposite defaults: desktop always shows exactly one
         chapter, mobile starts with all of them collapsed. Crossing the
         breakpoint (rotation, resize) has to re-apply the right one - otherwise
         a rotated phone lands on the desktop layout with nothing open at all,
         which hides every chapter. */
      applyBreakpointDefaults() {
        if (!this.mqDesktop.matches) {
          this.chapters.forEach(function (chapter) { this.closeChapter(chapter.id); }, this);
          return;
        }
        var current = this.chapters.filter(function (chapter) {
          return chapter.hasAttribute('data-open');
        })[0] || this.chapters[0];
        if (current) this.openChapter(current.id, { scroll: false });
      }

      openChapter(id, options) {
        options = options || {};
        this.navItems.forEach(function (item) {
          if (item.dataset.target === id) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });
        this.chapters.forEach(function (chapter) {
          var isTarget = chapter.id === id;
          var toggle = chapter.querySelector('[data-care-chapter-toggle]');
          if (isTarget) {
            chapter.setAttribute('data-open', '');
            this.resetSteps(chapter);
          } else {
            chapter.removeAttribute('data-open');
          }
          if (toggle) toggle.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        }, this);
        if (options.scroll) {
          var target = this.querySelector('#' + id);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      /* Back to the chapter's default state: only its first step is expanded. */
      resetSteps(chapter) {
        var rows = chapter.querySelectorAll('.pm-care-guide__accordion-row');
        Array.prototype.forEach.call(rows, function (row, index) {
          if (index === 0) return;
          row.open = false;
        });
        if (rows[0]) rows[0].open = true;
      }

      closeChapter(id) {
        var chapter = this.querySelector('#' + id);
        if (!chapter) return;
        chapter.removeAttribute('data-open');
        var toggle = chapter.querySelector('[data-care-chapter-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }

      onNavItemClick(event) {
        var item = event.currentTarget;
        event.preventDefault();
        this.openChapter(item.dataset.target, { scroll: true });
      }

      onChapterToggleClick(chapter) {
        if (this.mqDesktop.matches) return;
        if (chapter.hasAttribute('data-open')) {
          this.closeChapter(chapter.id);
        } else {
          this.openChapter(chapter.id, { scroll: false });
        }
      }
    }
  );
}
